import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.css";
import App from "./App";
import router from "./router";
import store from "./store";
import Carousel3d from "vue-carousel-3d";
import firebase from "firebase/app";
import i18n from "./i18n";
import moment from "moment";

Vue.use(Vuetify);
Vue.use(Carousel3d);

firebase.auth().onAuthStateChanged(async user => {
  if (user) {
    try {
      const verifiedUser = await store.dispatch("verifyLogin", user.uid);
      store.commit("SET_USER", verifiedUser);
      router.push("/");

    } catch (err) {
      // console.log(err, "Error message from main.js");
      store.commit("SET_LOGIN_ERROR", err);
      firebase.auth().signOut()
        .catch(err => {
          console.log(err);
        });
    }
  } else {
    router.push("/Splash");
  }
});

// if (firebase.auth().currentUser === undefined || firebase.auth().currentUser === null) {
//   store.dispatch("initializeIPC");
// }


Vue.config.productionTip = false;

Vue.config.errorHandler = (err, vm, info) => {
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in. Only available in 2.2.0+
  const player = vm.$store.getters.getPlayer;
  const errorObject = {
    error: {
      message: err.message,
      stack: err.stack
    },
    playerID: player ? player.id : "",
    info,
    date: moment().format("HH:mm:ss DD.MM.YYYY")
  };
  vm.$store.dispatch("sendError", errorObject);
  console.log(errorObject);

};

// 1800000
/* eslint-disable no-new */
new Vue({
  components: { App },
  router,
  i18n,
  store,
  template: "<App/>"
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js